import React from 'react'
import { bool, node, string } from 'prop-types'
import classNames from 'classnames'

import styles from './Blockquote.module.scss'

import Type from '../Type'
import Icon from '../Icon'
import ButtonStandard from '../ButtonStandard'

const Blockquote = ({
  children,
  attribution,
  secondaryAttribution,
  buttonText,
  buttonLink,
  inverse
}) => (
  <blockquote
    className={classNames(styles.BlockquoteWrapper, inverse && styles.inverse)}
  >
    <div className={styles.Blockquote}>
      <Type
        as="div"
        size="body1"
        weight="medium"
        className={styles.BlockquoteQuote}
      >
        {children}
      </Type>

      <div className={styles.BlockQuoteFooter}>
        {{ attribution } && (
          <Type
            themed
            as="span"
            size={['body2', 'body3']}
            weight="medium"
            className={styles.BlockquoteAttribution}
          >
            {attribution}
            {secondaryAttribution && <div>{secondaryAttribution}</div>}
          </Type>
        )}

        {buttonText && (
          <ButtonStandard
            outline
            size="small"
            icon="arrow-right"
            href={buttonLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            {buttonText}
          </ButtonStandard>
        )}
      </div>

      <Icon
        type="quotationMarks"
        size="44"
        className={classNames(styles.BlockquoteQuotationMarks)}
      />
    </div>
  </blockquote>
)

Blockquote.propTypes = {
  children: node.isRequired,
  attribution: string,
  secondaryAttribution: string,
  buttonText: string,
  buttonLink: string,
  inverse: bool
}

export default Blockquote
